// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"037f9606","217":"12f3d261","303":"d4c049b8","389":"b76dd6b4","453":"46dc3e92","788":"75929cac","841":"d7deaee2","997":"3bc5e23d"}[chunkId] + ".chunk.js";
};